import { useConfigQuery } from "@hooks";

import * as Apis from "../api";

const useDashboardQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default useDashboardQuery;
